// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2cZ9W","name":"Header_name__1q9Ty","birthday":"Header_birthday__27ClG","skeleton":"Header_skeleton__hgkqv"};